import { Model } from "./model";

export class Announcement extends Model {
	private body: string = "";
	private title: string = "";
	private link: string = "";
	private image: string = "";
	private link_description: string = "";

	public getBody(): string {
		return this.body;
	}

	public setTitle(s: string): void {
		this.title = s;
	}

	public getTitle(): string {
		return this.title;
	}

	public getLink(): string {
		return this.link;
	}

	public getLinkDescription(): string {
		return this.link_description;
	}

	public hasLinkDescription(): boolean {
		return !!this.link_description;
	}

	public hasLink(): boolean {
		return this.link.length > 0;
	}

	public setImageSource(s: string): void {
		this.image = s;
	}

	public getImageSource(): string {
		return this.image;
	}

	public hasImageSource(): boolean {
		return this.image.length > 0;
	}
}
